module.exports = __webpack_public_path__ + "static/media/logo-en.3cdcb503.png";